// Curated preset avatars — football & tribal themed.
// Each avatar is "iconKey:colorKey" e.g. "ball:yellow"
// To add new ones: add iconKey to ICONS and (if new) colorKey to COLORS.

export const COLORS = {
  yellow:  { bg: "#E3FF00", fg: "#000",    label: "Yellow" },
  amber:   { bg: "#F59E0B", fg: "#000",    label: "Amber"  },
  red:     { bg: "#EF4444", fg: "#fff",    label: "Red"    },
  pink:    { bg: "#EC4899", fg: "#fff",    label: "Pink"   },
  purple:  { bg: "#A855F7", fg: "#fff",    label: "Purple" },
  blue:    { bg: "#3B82F6", fg: "#fff",    label: "Blue"   },
  cyan:    { bg: "#06B6D4", fg: "#000",    label: "Cyan"   },
  emerald: { bg: "#10B981", fg: "#000",    label: "Emerald"},
  slate:   { bg: "#475569", fg: "#fff",    label: "Slate"  },
  white:   { bg: "#F3F4F6", fg: "#0B0D11", label: "Chalk"  },
};

export const ICONS = [
  { key: "ball",       label: "Ball"      },
  { key: "trophy",     label: "Trophy"    },
  { key: "medal",      label: "Medal"     },
  { key: "crown",      label: "Crown"     },
  { key: "shield",     label: "Shield"    },
  { key: "fire",       label: "Fire"      },
  { key: "lightning",  label: "Lightning" },
  { key: "star",       label: "Star"      },
  { key: "target",     label: "Target"    },
  { key: "rocket",     label: "Rocket"    },
  { key: "diamond",    label: "Diamond"   },
  { key: "sparkle",    label: "Sparkle"   },
];

// 12 icons × 5 hand-picked colour pairings = 60-ish presets. We narrow to ~30
// curated combos so the picker stays scannable.
export const PRESETS = [
  // Sporty foundations
  "ball:yellow", "ball:cyan", "ball:white",
  "trophy:yellow", "trophy:amber", "trophy:purple",
  "medal:amber", "medal:slate",
  "crown:yellow", "crown:purple", "crown:pink",
  "shield:yellow", "shield:red", "shield:blue", "shield:emerald",
  // Energy
  "fire:red", "fire:amber",
  "lightning:yellow", "lightning:cyan",
  "star:yellow", "star:purple", "star:pink",
  "target:emerald", "target:red",
  // Hype
  "rocket:cyan", "rocket:pink",
  "diamond:cyan", "diamond:purple",
  "sparkle:yellow", "sparkle:pink",
];

export const DEFAULT_AVATAR = "ball:yellow";

export const parseAvatar = (avatar) => {
  if (!avatar || typeof avatar !== "string") return parseAvatar(DEFAULT_AVATAR);
  const [icon, color] = avatar.split(":");
  if (!ICONS.find((i) => i.key === icon) || !COLORS[color]) {
    return parseAvatar(DEFAULT_AVATAR);
  }
  return { icon, color, ...COLORS[color] };
};

export const isValidAvatar = (avatar) => {
  if (!avatar || typeof avatar !== "string") return false;
  const [icon, color] = avatar.split(":");
  return !!(ICONS.find((i) => i.key === icon) && COLORS[color]);
};
